import { HomeIcon, UsersIcon, KeyIcon } from '@heroicons/vue/24/outline'
import type { NavGroup } from '@/types/navigation.types'

/**
 * Sidebar navigation config.
 * Labels are i18n keys resolved at render time via $t().
 * Groups are separated by dividers in the sidebar.
 * Visibility is controlled by the `roles` array on each item/group.
 *
 * Add domain-entity items here as you build them — see
 * docs/guides/adding-entities.md → "Register in Sidebar Navigation".
 */
export const navigationGroups: NavGroup[] = [
  {
    id: 'main',
    access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
    items: [
      {
        routeName: 'dashboard',
        label: 'nav.home',
        icon: HomeIcon,
        access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
      },
      {
        routeName: 'users-list',
        label: 'nav.users',
        icon: UsersIcon,
        access_levels: ['access_level.admin'],
      },
      {
        routeName: 'settings-fiscozen-api-key',
        label: 'nav.settings',
        icon: KeyIcon,
        access_levels: ['access_level.admin'],
      },
    ],
  },
]
